var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(2.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2347,1.039 C11.8607,0.011 14.0207,-0.273 15.8867,0.325 C19.9457,1.634 21.2057,6.059 20.0787,9.58 C18.3397,15.11 10.9127,19.235 10.5977,19.408 C10.4857,19.47 10.3617,19.501 10.2377,19.501 C10.1137,19.501 9.9907,19.471 9.8787,19.41 C9.5657,19.239 2.1927,15.175 0.3957,9.581 C0.3947,9.581 0.3947,9.58 0.3947,9.58 C-0.7333,6.058 0.5227,1.632 4.5777,0.325 C6.4817,-0.291 8.5567,-0.02 10.2347,1.039 Z M5.0377,1.753 C1.7567,2.811 0.9327,6.34 1.8237,9.123 C3.2257,13.485 8.7647,17.012 10.2367,17.885 C11.7137,17.003 17.2927,13.437 18.6497,9.127 C19.5407,6.341 18.7137,2.812 15.4277,1.753 C13.8357,1.242 11.9787,1.553 10.6967,2.545 C10.4287,2.751 10.0567,2.755 9.7867,2.551 C8.4287,1.53 6.6547,1.231 5.0377,1.753 Z M14.4677,3.7389 C15.8307,4.1799 16.7857,5.3869 16.9027,6.8139 C16.9357,7.2269 16.6287,7.5889 16.2157,7.6219 C16.1947,7.6239 16.1747,7.6249 16.1537,7.6249 C15.7667,7.6249 15.4387,7.3279 15.4067,6.9359 C15.3407,6.1139 14.7907,5.4199 14.0077,5.1669 C13.6127,5.0389 13.3967,4.6159 13.5237,4.2229 C13.6527,3.8289 14.0717,3.6149 14.4677,3.7389 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.0337ccb77692bbbf291e1f91fcb76a0c.svg";
export { ForwardRef as ReactComponent };